import { render, staticRenderFns } from "./MealsCardsView.vue?vue&type=template&id=4f86a57a&scoped=true"
import script from "./MealsCardsView.vue?vue&type=script&lang=js"
export * from "./MealsCardsView.vue?vue&type=script&lang=js"
import style0 from "./MealsCardsView.vue?vue&type=style&index=0&id=4f86a57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86a57a",
  null
  
)

export default component.exports